import React from 'react';
import { NavLink } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { ChevronRight } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import Slider from '../../../commons/Slider';

const useCarouselStyles = makeStyles(theme => ({
  rowHeader: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(2, 2, 0.5, 2),
    '& > *': {
      margin: theme.spacing(0.5)
    }
  },
  headerSubtitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.secondary.main,
    textDecoration: 'none'
  },
  centeredFlex: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  invisibleCarousel: {
    width: '100%',
    height: '1184px'
  },
  skeletonCarousel: {
    width: '100%',
    height: '600px',
    overflow: 'hidden'
  },
  skeletonHeader: {
    width: '400px',
    padding: theme.spacing(2)
  },
  miniatureSkeletons: {
    display: 'flex'
  },
  skeletonRect: {
    margin: theme.spacing(1),
    minWidth: '235px',
    minHeight: '460px'
  }
}));

const useSeeMoreStyles = makeStyles(theme => ({
  seeMore: {
    minWidth: '270px',
    height: '510px',
    marginTop: theme.spacing(1),
    backgroundColor: 'rgb(252, 247, 242)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    boxShadow: '0 3px 15px 0 rgba(0, 0, 0, 0.1)',
    '& > *': {
      color: '#414042',
      fontWeight: 600,
      fontSize: '1.5rem',
      display: 'flex',
      alignItems: 'center'
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: '180px',
      maxWidth: '180px',
      height: '372px'
    }
  }
}));

const SeeMore = props => {
  const classes = useSeeMoreStyles(props);
  const { carouselLink } = props;
  return (
    <NavLink to={carouselLink} className={classes.seeMore}>
      <Typography>
        Ver más
        <ChevronRight color="primary" />
      </Typography>
    </NavLink>
  );
};

const Carousel = props => {
  const { carouselHeader, carouselLink, children, loading } = props;

  const classes = useCarouselStyles(props);

  // forceLoading prop is only for testing
  // TODO(toti): remove the prop option.
  if (
    (!children && loading && !props.noPlaceholder) ||
    (!children.length && loading && !props.noPlaceholder) ||
    props.forceLoading
  ) {
    return (
      <div className={classes.skeletonCarousel}>
        <div className={classes.rowHeader}>
          <Skeleton variant="rect" width={200} height={30} />
        </div>
        <div className={classes.miniatureSkeletons}>
          {
            /* eslint-disable react/no-array-index-key */
            new Array(8).fill(0).map((_, index) => (
              <Skeleton
                key={index}
                className={classes.skeletonRect}
                variant="rect"
                width={235}
                height={460}
              />
            ))
            /* eslint-enable react/no-array-index-key */
          }
        </div>
      </div>
    );
  }

  if ((!children.length && !loading) || (loading && props.noPlaceholder)) {
    return '';
  }

  return (
    <div className={classes.homeRow}>
      <div className={classes.rowHeader}>
        <Typography
          variant="h6"
          component="h2"
          color="secondary"
          style={{ fontWeight: 500 }}
        >
          {carouselHeader}
        </Typography>
        <Typography
          component={NavLink}
          to={carouselLink}
          className={classes.headerSubtitle}
        >
          · ver todo
          <ChevronRight color="primary" />
        </Typography>
      </div>
      <Slider productSlider>
        {children}
        <SeeMore carouselLink={carouselLink} />
      </Slider>
    </div>
  );
};

export default Carousel;
